"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ActionAfterViewed = require("./ActionAfterViewed");
Object.keys(_ActionAfterViewed).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ActionAfterViewed[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ActionAfterViewed[key];
    }
  });
});